import RecommendIcon from '@mui/icons-material/Recommend';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';

export const values = [
    {
        name:"Quality",
        description:"Delivering a product of the highest quality with no faults or comebacks",
        icon:<RecommendIcon/>,
    },
    {
        name:"Price",
        description:"Delivering a product of the highest quality at the best possible price ensuring value for money. ",
        icon:<CreditCardIcon/>,
    },
    {
        name:"Delivery",
        description:"Delivering a product of the highest quality in the shortest possible time. ",
        icon:<DeliveryDiningIcon/>,
    }
]